const printPDFWithReportTitle = (currentReportData) => {
  const currentTitle = document.title;
  document.title = currentReportData?.data?.report_name;
  window.print();
  document.title = currentTitle;
};

export default printPDFWithReportTitle;
